/** ISO 639-1 언어 코드 목록 (원본 @gc/common/constants/language_iso 기반) */
export interface LanguageOption {
  value: string;
  text: string;
}

const RAW: LanguageOption[] = [
  { value: 'aa', text: 'Afar' },
  { value: 'ab', text: 'Abkhazian' },
  { value: 'af', text: 'Afrikaans' },
  { value: 'ak', text: 'Akan' },
  { value: 'sq', text: 'Albanian' },
  { value: 'am', text: 'Amharic' },
  { value: 'ar', text: 'Arabic' },
  { value: 'an', text: 'Aragonese' },
  { value: 'hy', text: 'Armenian' },
  { value: 'as', text: 'Assamese' },
  { value: 'av', text: 'Avaric' },
  { value: 'ae', text: 'Avestan' },
  { value: 'ay', text: 'Aymara' },
  { value: 'az', text: 'Azerbaijani' },
  { value: 'ba', text: 'Bashkir' },
  { value: 'bm', text: 'Bambara' },
  { value: 'eu', text: 'Basque' },
  { value: 'be', text: 'Belarusian' },
  { value: 'bn', text: 'Bengali' },
  { value: 'bh', text: 'Bihari languages' },
  { value: 'bi', text: 'Bislama' },
  { value: 'bo', text: 'Tibetan' },
  { value: 'bs', text: 'Bosnian' },
  { value: 'br', text: 'Breton' },
  { value: 'bg', text: 'Bulgarian' },
  { value: 'my', text: 'Burmese' },
  { value: 'ca', text: 'Catalan; Valencian' },
  { value: 'cs', text: 'Czech' },
  { value: 'ch', text: 'Chamorro' },
  { value: 'ce', text: 'Chechen' },
  { value: 'zh', text: 'Chinese' },
  { value: 'cu', text: 'Church Slavic' },
  { value: 'cv', text: 'Chuvash' },
  { value: 'kw', text: 'Cornish' },
  { value: 'co', text: 'Corsican' },
  { value: 'cr', text: 'Cree' },
  { value: 'cy', text: 'Welsh' },
  { value: 'da', text: 'Danish' },
  { value: 'de', text: 'German' },
  { value: 'dv', text: 'Divehi; Dhivehi; Maldivian' },
  { value: 'nl', text: 'Dutch; Flemish' },
  { value: 'dz', text: 'Dzongkha' },
  { value: 'el', text: 'Greek, Modern (1453-)' },
  { value: 'en', text: 'English' },
  { value: 'eo', text: 'Esperanto' },
  { value: 'et', text: 'Estonian' },
  { value: 'ee', text: 'Ewe' },
  { value: 'fo', text: 'Faroese' },
  { value: 'fa', text: 'Persian' },
  { value: 'fj', text: 'Fijian' },
  { value: 'fi', text: 'Finnish' },
  { value: 'fil', text: 'Filipino' },
  { value: 'fr', text: 'French' },
  { value: 'fy', text: 'Western Frisian' },
  { value: 'ff', text: 'Fulah' },
  { value: 'ka', text: 'Georgian' },
  { value: 'gd', text: 'Gaelic; Scottish Gaelic' },
  { value: 'ga', text: 'Irish' },
  { value: 'gl', text: 'Galician' },
  { value: 'gv', text: 'Manx' },
  { value: 'gn', text: 'Guarani' },
  { value: 'gu', text: 'Gujarati' },
  { value: 'ht', text: 'Haitian; Haitian Creole' },
  { value: 'ha', text: 'Hausa' },
  { value: 'he', text: 'Hebrew' },
  { value: 'hz', text: 'Herero' },
  { value: 'hi', text: 'Hindi' },
  { value: 'ho', text: 'Hiri Motu' },
  { value: 'hr', text: 'Croatian' },
  { value: 'hu', text: 'Hungarian' },
  { value: 'ig', text: 'Igbo' },
  { value: 'is', text: 'Icelandic' },
  { value: 'io', text: 'Ido' },
  { value: 'ii', text: 'Sichuan Yi; Nuosu' },
  { value: 'iu', text: 'Inuktitut' },
  { value: 'ie', text: 'Interlingue; Occidental' },
  { value: 'ia', text: 'Interlingua' },
  { value: 'id', text: 'Indonesian' },
  { value: 'ik', text: 'Inupiaq' },
  { value: 'it', text: 'Italian' },
  { value: 'jv', text: 'Javanese' },
  { value: 'ja', text: 'Japanese' },
  { value: 'kl', text: 'Kalaallisut; Greenlandic' },
  { value: 'kn', text: 'Kannada' },
  { value: 'ks', text: 'Kashmiri' },
  { value: 'kr', text: 'Kanuri' },
  { value: 'kk', text: 'Kazakh' },
  { value: 'km', text: 'Central Khmer' },
  { value: 'ki', text: 'Kikuyu; Gikuyu' },
  { value: 'rw', text: 'Kinyarwanda' },
  { value: 'ky', text: 'Kirghiz; Kyrgyz' },
  { value: 'kv', text: 'Komi' },
  { value: 'kg', text: 'Kongo' },
  { value: 'ko', text: 'Korean' },
  { value: 'kj', text: 'Kuanyama; Kwanyama' },
  { value: 'ku', text: 'Kurdish' },
  { value: 'lo', text: 'Lao' },
  { value: 'la', text: 'Latin' },
  { value: 'lv', text: 'Latvian' },
  { value: 'li', text: 'Limburgan; Limburger; Limburgish' },
  { value: 'ln', text: 'Lingala' },
  { value: 'lt', text: 'Lithuanian' },
  { value: 'lb', text: 'Luxembourgish; Letzeburgesch' },
  { value: 'lu', text: 'Luba-Katanga' },
  { value: 'lg', text: 'Ganda' },
  { value: 'mk', text: 'Macedonian' },
  { value: 'mh', text: 'Marshallese' },
  { value: 'ml', text: 'Malayalam' },
  { value: 'mi', text: 'Maori' },
  { value: 'mr', text: 'Marathi' },
  { value: 'ms', text: 'Malay' },
  { value: 'mg', text: 'Malagasy' },
  { value: 'mt', text: 'Maltese' },
  { value: 'mn', text: 'Mongolian' },
  { value: 'na', text: 'Nauru' },
  { value: 'nv', text: 'Navajo; Navaho' },
  { value: 'nr', text: 'Ndebele, South; South Ndebele' },
  { value: 'nd', text: 'Ndebele, North; North Ndebele' },
  { value: 'ng', text: 'Ndonga' },
  { value: 'ne', text: 'Nepali' },
  { value: 'nn', text: 'Norwegian Nynorsk; Nynorsk, Norwegian' },
  { value: 'nb', text: 'Norwegian Bokmal' },
  { value: 'no', text: 'Norwegian' },
  { value: 'ny', text: 'Chichewa; Chewa; Nyanja' },
  { value: 'oc', text: 'Occitan (post 1500)' },
  { value: 'oj', text: 'Ojibwa' },
  { value: 'or', text: 'Oriya' },
  { value: 'om', text: 'Oromo' },
  { value: 'os', text: 'Ossetian; Ossetic' },
  { value: 'pa', text: 'Panjabi; Punjabi' },
  { value: 'pi', text: 'Pali' },
  { value: 'pl', text: 'Polish' },
  { value: 'pt', text: 'Portuguese' },
  { value: 'ps', text: 'Pushto; Pashto' },
  { value: 'qu', text: 'Quechua' },
  { value: 'rm', text: 'Romansh' },
  { value: 'ro', text: 'Romanian; Moldavian; Moldovan' },
  { value: 'rn', text: 'Rundi' },
  { value: 'ru', text: 'Russian' },
  { value: 'sg', text: 'Sango' },
  { value: 'sa', text: 'Sanskrit' },
  { value: 'si', text: 'Sinhala; Sinhalese' },
  { value: 'sk', text: 'Slovak' },
  { value: 'sl', text: 'Slovenian' },
  { value: 'se', text: 'Northern Sami' },
  { value: 'sm', text: 'Samoan' },
  { value: 'sn', text: 'Shona' },
  { value: 'sd', text: 'Sindhi' },
  { value: 'so', text: 'Somali' },
  { value: 'st', text: 'Sotho, Southern' },
  { value: 'es', text: 'Spanish; Castilian' },
  { value: 'sc', text: 'Sardinian' },
  { value: 'sr', text: 'Serbian' },
  { value: 'ss', text: 'Swati' },
  { value: 'su', text: 'Sundanese' },
  { value: 'sw', text: 'Swahili' },
  { value: 'sv', text: 'Swedish' },
  { value: 'ty', text: 'Tahitian' },
  { value: 'ta', text: 'Tamil' },
  { value: 'tt', text: 'Tatar' },
  { value: 'te', text: 'Telugu' },
  { value: 'tg', text: 'Tajik' },
  { value: 'tl', text: 'Tagalog' },
  { value: 'th', text: 'Thai' },
  { value: 'ti', text: 'Tigrinya' },
  { value: 'to', text: 'Tonga (Tonga Islands)' },
  { value: 'tn', text: 'Tswana' },
  { value: 'ts', text: 'Tsonga' },
  { value: 'tk', text: 'Turkmen' },
  { value: 'tr', text: 'Turkish' },
  { value: 'tw', text: 'Twi' },
  { value: 'ug', text: 'Uighur; Uyghur' },
  { value: 'uk', text: 'Ukrainian' },
  { value: 'ur', text: 'Urdu' },
  { value: 'uz', text: 'Uzbek' },
  { value: 've', text: 'Venda' },
  { value: 'vi', text: 'Vietnamese' },
  { value: 'vo', text: 'Volapuk' },
  { value: 'wa', text: 'Walloon' },
  { value: 'wo', text: 'Wolof' },
  { value: 'xh', text: 'Xhosa' },
  { value: 'yi', text: 'Yiddish' },
  { value: 'yo', text: 'Yoruba' },
  { value: 'za', text: 'Zhuang; Chuang' },
  { value: 'zu', text: 'Zulu' },
];

/** 중복 value 제거 (원본 lodash uniqBy 동일) */
const seen = new Set<string>();
export const LANGUAGE_ISO: LanguageOption[] = RAW.filter((item) => {
  if (seen.has(item.value)) return false;
  seen.add(item.value);
  return true;
});
